export default [
  'BOTServiceHistoryNew'
]

/*
Appears on:
my-account/service-history,
*/
